import { createApiInstance } from "./index";

const api = createApiInstance();

/**
 * 取得 captcha 圖片（blob）
 */
export const getCaptcha = async () => {
  const res = await fetch('/api/get_captcha/', {
    method: 'POST',
    credentials: 'include',
  });

  if (!res.ok) {
    const error = new Error('captcha error');
    error.__handled = true;
    throw error;
  }

  return res.blob();
};


/**
 * 寄送雙重驗證碼
 * @param {string} acct_uuid
 */
export const createAuthCodeAndSend = async (acct_uuid) => {
  const response = await api.post('create_auth_code_and_send/', { acct_uuid });
  return response.data;
};

/**
 * 驗證雙重驗證碼
 * @param {Object} payload
 * @param {string} payload.acct_uuid
 * @param {string} payload.auth_code
 */
export const checkAuthCode = async (payload) => {
  const response = await api.post('check_auth_code/', payload);
  return response.data;
};


/**
 * 檢查忘記密碼連結是否有效
 * @param {string} resetId
 */
export const checkForgetPwdById = async (resetId) => {
  const response = await api.post('check_forget_pwd_by_id/', { reset_id: resetId });
  return response.data;
};

/**
 * 設定新密碼 (忘記密碼流程)
 * @param {string} resetId
 * @param {string} pwd
 */
export const setForgetPwd = async (resetId, pwd) => {
  const response = await api.post('set_forget_pwd/', { reset_id: resetId, pwd });
  return response.data;
};
